import { StateCreator } from "zustand";

export interface DashboardViewerState {
    url?: string;
    visible: boolean;
}

export interface DashboardViewerSlice {
    dashboardViewer: DashboardViewerState;
    setDashboardViewer: (state: DashboardViewerState) => void;
    updateDashboardViewer: (partialState: Partial<DashboardViewerState>) => void;
    showDashboardViewer: () => void;
    hideDashboardViewer: () => void;
}

const initialDashboardViewerState: DashboardViewerState = { url: undefined, visible: false };

export const createDashboardViewerSlice: StateCreator<DashboardViewerSlice, [], [], DashboardViewerSlice> = (set) => ({
    dashboardViewer: initialDashboardViewerState,

    setDashboardViewer: (state) => set({ dashboardViewer: state }),
    updateDashboardViewer: (partialState) => set((state) => ({ dashboardViewer: { ...state.dashboardViewer, ...partialState } })),
    showDashboardViewer: () => set((state) => ({ dashboardViewer: { ...state.dashboardViewer, visible: true } })),
    hideDashboardViewer: () => set((state) => ({ dashboardViewer: { ...state.dashboardViewer, visible: false } })),
});

